import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { Box, Typography } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import { infoManual, infoManualTwo } from "./parts";
import { httpAPI_APP111, httpAPI_COM005, httpAPI_PRE011 } from "./api/request";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { FormKbn } from "../../assets/data/Constants";
import "./_style.scss";

/**
 * SCRC080007 掛金納付対象職員
 * @returns JSX.Element SCRC080007 掛金納付対象職員
 */
const SCRC080007 = () => {
  const navigate = useNavigate();
  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  const location = useLocation();
  const year = location?.state?.year
    ? location?.state?.year
    : state.authInfo?.fiscalYear;
  const [disFrom, setDisFrom] = useState(true);
  const [disPre, setDisPre] = useState(true);
  const [fromName, setFromName] = useState("");
  const [fromBase64, setFromBase64] = useState("");
  const [preName, setPreName] = useState("");
  const [preBase64, setPreBase64] = useState("");
  const [fromRequestId, setFromRequestId] = useState<string>("");
  const [preRequestId, setPreRequestId] = useState<string>("");
  const [conPreButton, setConPreButton] = useState(false);
  const [stopApiRequest, setStopApiRequest] = useState(false);
  const timerId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    handleInit();
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 非同期処理（掛金納付対象職員届提出控え・振込依頼書参照）
  const handleInit = async () => {
    try {
      const res = await httpAPI_PRE011({
        contractorNo: state.authInfo?.contractorNo!,
        formList: [
          {
            formClass: "RPT0301009",
            formKbn: FormKbn["申請"],
          },
          {
            formClass: "RPT0102029",
            formKbn: FormKbn["申請"],
          },
        ],
        year: location?.state?.year ? location?.state?.year : null,
      });

      if (res.resultCd === "I0000") {
        let disFrom = true;
        let disPre = true;
        res.formList?.forEach((form) => {
          // 帳票出力リスト.帳票出力状態が"3"(出力完了)のレコードが存在する場合
          if (form.formOutputStatus === "3") {
            // 既契約掛金振込用紙依頼書
            if (form.formClass === "RPT0102029") {
              // 「振込依頼書ダウンロード」ボタンを活性化する
              disFrom = false;
              setFromRequestId(form.requestId!);
              setDisFrom(disFrom);
            } else if (form.formClass === "RPT0301009") {
              // 「掛金納付対象職員届控えダウンロード」ボタンを活性化する
              disPre = false;
              setPreRequestId(form.requestId!);
              setDisPre(disPre);
            }
          }
        });

        if (!disFrom && !disPre) {
          setStopApiRequest(true);
          clearTimeout(timerId.current!);
        } else {
          if (res.formList?.some((form) => form.formOutputStatus === "1")) {
            setState({ ...state, errorMsgId: "TKMSG_SCR0003I" });
          }
          // 10秒間待機後 再度APIリクエストを送信
          if (!stopApiRequest) {
            timerId.current = setTimeout(() => {
              handleInit();
            }, 10000);
          }
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (fromRequestId) {
      handLedger(fromRequestId, "form");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromRequestId]);

  useEffect(() => {
    if (preRequestId) {
      handLedger(preRequestId, "pre");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preRequestId]);

  const handLedger = async (requestId: string, type: "form" | "pre") => {
    try {
      const res = await httpAPI_COM005({
        formList: [{ requestId: requestId }],
      });

      if (res.resultCd === "I0000") {
        if (type === "form") {
          setFromName(res.formList?.[0].fileName ?? "");
          setFromBase64(res.formList?.[0].fileBase64 ?? "");
        } else {
          setPreName(res.formList?.[0].fileName ?? "");
          setPreBase64(res.formList?.[0].fileBase64 ?? "");
        }
        setState({ ...state, errorMsgId: "" });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleComplete = async () => {
    try {
      const res = await httpAPI_APP111({
        contractorNo: state.authInfo?.contractorNo!,
        year: year,
      });

      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRC020001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC080007PageForTest" className="SCRC080007">
      <Box className="SCRC080007InfoManual">
        <Typography>
          　　
          {year}
          {infoManual}
        </Typography>
      </Box>
      <Box className="SCRC080007InfoManualTwo">
        <TkInfoManual rule={"<"}>{infoManualTwo}</TkInfoManual>
      </Box>
      <Box>
        <TkDownloadLink
          dataname={fromName}
          base64filedata={fromBase64}
          isButton={true}
          buttonName="振込依頼書ダウンロード"
          buttonDisabled={disFrom}
          linkDisabled={disFrom}
          downloadBase64={true}
        />
      </Box>
      <Box className="SCRC080007InfoManual">
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLC080007_02}
        </TkInfoManual>
      </Box>
      <Box>
        <TkDownloadLink
          dataname={preName}
          base64filedata={preBase64}
          isButton={true}
          buttonName="掛金納付対象職員届控えダウンロード"
          buttonDisabled={disPre}
          linkDisabled={disPre}
          onClick={() => {
            setConPreButton(true);
          }}
          downloadBase64={true}
        />
      </Box>
      <Box className="SCRC080007Button">
        <TkButton
          disabled={!conPreButton}
          onClick={() => {
            handleComplete();
          }}
        >
          手続き完了
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRC080007;
